import { getErrorResponse } from '../../../../../common/api/errors'

/**
 * Текст ошибки для оператора из отказа запроса настроек.
 *
 * Ответ приходит в конверте бэкенда (`errors.general_error`); форма `error` — это ответ
 * самого сервиса по контракту настроек, она понадобится, когда админка пойдёт в сервисы
 * напрямую, без прокси на бэкенде.
 */
export const extractSettingsError = (e: unknown, fallback: string): string =>
  getErrorResponse<{ general_error?: string }>(e)?.general_error ||
  (e as { data?: { error?: string } } | undefined)?.data?.error ||
  fallback
